<script setup lang="ts">
import WorkplaceFeature from '~/components/WorkplaceFeature.vue';

const scrollingToTarget = useScrollingToTarget();
let sections: NodeListOf<HTMLElement>;
let hashObserver: IntersectionObserver;
let updateTickerPosition: (() => void) | undefined;
const hasScrolled = ref(false);

const appMounted = useState('appMounted');
const {sendScreenView} = useAnalytics();
if (appMounted.value) sendAnalytics();
watch(appMounted, () => sendAnalytics);

function sendAnalytics() {
  sendScreenView({type: 'PageView', target: 'index'}, true);
}

onMounted(() => {
  updateTickerPosition = () => {
    hasScrolled.value = window.scrollY > 0;
  };

  updateTickerPosition();
  window.addEventListener('scroll', updateTickerPosition, {passive: true});

  hashObserver = new IntersectionObserver(
    (entries: IntersectionObserverEntry[]) => {
      if (!scrollingToTarget.value) {
        if (entries[0].isIntersecting) {
          const id = entries[0].target.id;
          sendScreenView({
            type: 'view',
            target: id,
          });
        }
      }
    },
    {rootMargin: '-20% 0px -20% 0px'},
  );

  sections = document.querySelectorAll('section');
  sections.forEach((section) => {
    hashObserver.observe(section);
  });
});

onBeforeUnmount(() => {
  if (updateTickerPosition) window.removeEventListener('scroll', updateTickerPosition);
  hashObserver?.disconnect();
});
</script>

<template>
  <main class="container home">
    <section id="feature" class="observable feature-section">
      <div class="anchor" />
      <feature />
      <Ticker class="feature-ticker-top" :class="{'feature-ticker-scrolled': hasScrolled}" />
    </section>

    <section id="aboutUs" class="observable">
      <div class="anchor" />
      <about />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="workplaceOfTheFuture" class="observable">
      <WorkplaceFeature />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="mlsHq" class="observable">
      <MlsHq />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="mlsFeature" class="observable">
      <MlsFeature />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="experientialSpaces" class="observable" style="padding: 0">
      <div class="anchor" />
      <ExperientialSpacesHomeFeature />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="a250Feature" class="observable">
      <A250Feature />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="solutions" class="observable">
      <div class="anchor" />
      <SolutionsFeature />
    </section>

    <div style="background-color: black; height: 2rem" />

    <section id="deltaFeature" class="observable">
      <DeltaFeature />
    </section>

    <!-- <section id="infocomm2025" class="observable">
      <div class="anchor" />
      <Infocomm2025Feature />
    </section> -->

    <section id="platform" class="observable">
      <div class="anchor" />
      <ZenExperienceVideo />
    </section>

    <section id="whychoose" class="observable">
      <div class="anchor" />
      <platform />
    </section>

    <section id="checkPointFeature" class="observable">
      <CheckPointFeature />
    </section>

    <section id="partners" class="observable">
      <div class="anchor" />
      <Partners />
    </section>

    <section id="contact" class="observable">
      <div class="anchor" />
      <Contact />
    </section>
  </main>
</template>

<style lang="scss">
.feature-section {
  isolation: isolate;
  min-height: 100svh;
  position: relative;

  .feature-ticker-top {
    left: 0;
    position: absolute;
    top: 100svh;
    transform: translateY(-100%);
    transition: top 0.45s ease;
    width: 100%;
    z-index: 10;

    &.feature-ticker-scrolled {
      top: 100%;
    }
  }

}

</style>
